/* AMBITION — Galerie + Bewertungen.
   Rendert NUR echte Bewertungen aus dem Array "reviews" (Theme-Einstellung).
   Ist das Array leer, bleibt alles so, wie es ist: Foto + Bildunterschrift.
   Nichts wird erfunden – weder Namen noch Sterne noch "Verifizierter Kauf". */
(function () {
  'use strict';

  function esc(v) {
    return String(v == null ? '' : v)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function stars(rating) {
    var n = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
    if (!n) return '';
    var out = '<span class="lp-rev__stars" role="img" aria-label="' + n + ' von 5 Sternen">';
    for (var i = 1; i <= 5; i++) {
      out += '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">' +
             '<path class="lp-rev__star' + (i <= n ? '' : ' lp-rev__star--off') + '" ' +
             'd="M10 1.6l2.47 5.01 5.53.8-4 3.9.94 5.5L10 14.2l-4.94 2.6.94-5.5-4-3.9 5.53-.8z"/></svg>';
    }
    return out + '</span>';
  }

  function fmtDate(value, locale) {
    if (!value) return '';
    var d = new Date(value);
    if (isNaN(d.getTime())) return String(value);
    try { return d.toLocaleDateString(locale || 'de', { day: '2-digit', month: '2-digit', year: 'numeric' }); }
    catch (e) { return d.toISOString().slice(0, 10); }
  }

  function card(rev, labels, key) {
    var html = '';
    var head = '';
    if (rev.rating) head += stars(rev.rating);
    if (rev.name) head += '<span class="lp-rev__name">' + esc(rev.name) + '</span>';
    /* Das Siegel erscheint ausschliesslich, wenn verifiedPurchase true ist. */
    if (rev.verifiedPurchase === true) {
      head += '<span class="lp-rev__verified"><svg viewBox="0 0 20 20" aria-hidden="true">' +
              '<path d="M8.3 14.2l-4-4 1.4-1.4 2.6 2.6 6-6L15.7 6z"/></svg>' + esc(labels.verified) + '</span>';
    }
    if (head) html += '<div class="lp-rev__head">' + head + '</div>';

    var date = fmtDate(rev.date, labels.locale);
    if (date) html += '<p class="lp-rev__date">' + esc(date) + '</p>';
    if (rev.title) html += '<p class="lp-rev__title">' + esc(rev.title) + '</p>';
    if (rev.text) html += '<p class="lp-rev__text">' + esc(rev.text) + '</p>';

    var meta = [];
    if (rev.size) meta.push(esc(labels.sizeLabel) + ': ' + esc(rev.size));
    if (rev.color) meta.push(esc(labels.colorLabel) + ': ' + esc(rev.color));
    if (meta.length) html += '<p class="lp-rev__meta">' + meta.join(' &middot; ') + '</p>';

    if (html) {
      var count = Number(rev.helpful) || 0;
      html += '<button type="button" class="lp-rev__helpful" data-lp-rev-helpful data-key="' + esc(key) + '">' +
              '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M7 18H4V8h3zm2-10l3.2-6L14 3l-.9 5H17a2 2 0 012 2.3l-1.2 6A2 2 0 0115.8 18H9z"/></svg>' +
              '<span data-lp-rev-helpful-label>' + esc(labels.helpful) + (count ? ' (' + count + ')' : '') + '</span></button>';
    }
    return html;
  }

  function lightbox(labels) {
    var el = document.querySelector('[data-lp-rev-lb]');
    if (el) return el;
    el = document.createElement('div');
    el.className = 'lp-rev-lb';
    el.setAttribute('data-lp-rev-lb', '');
    el.innerHTML = '<button type="button" class="lp-rev-lb__x" data-lp-rev-lb-x aria-label="' +
                   esc(labels.close) + '">&times;</button><img alt="">';
    document.body.appendChild(el);
    function close() { el.removeAttribute('open'); document.documentElement.style.overflow = ''; }
    el.addEventListener('click', function (e) { if (e.target === el || e.target.closest('[data-lp-rev-lb-x]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el.hasAttribute('open')) close(); });
    return el;
  }

  function init(section) {
    if (section.dataset.lpRevReady) return;
    section.dataset.lpRevReady = '1';

    var dataEl = section.querySelector('[data-lp-rev-data]');
    var labelEl = section.querySelector('[data-lp-rev-labels]');
    var labels = { verified: 'Verifizierter Kauf', helpful: 'Hilfreich', sizeLabel: 'Größe',
                   colorLabel: 'Farbe', thanks: 'Danke für dein Feedback', close: 'Schließen', locale: 'de' };
    try { Object.assign(labels, JSON.parse(labelEl.textContent)); } catch (e) {}

    /* Array mit echten Bewertungen. Leer, bis welche eingetragen werden. */
    var reviews = [];
    try {
      var parsed = JSON.parse((dataEl && dataEl.textContent || '[]').trim() || '[]');
      if (Array.isArray(parsed)) reviews = parsed;
    } catch (e) {
      if (window.console) console.warn('[lp-review-gallery] "Bewertungen (JSON)" ist kein gültiges JSON – es wird nichts angezeigt.');
    }
    window.reviews = reviews;

    var items = Array.prototype.slice.call(section.querySelectorAll('[data-lp-rev-item]'));
    items.forEach(function (item, i) {
      var box = item.querySelector('[data-lp-rev-card]');
      if (!box) return;
      var rev = reviews.filter(function (r) {
        return r && (Number(r.photo) === i + 1 || (r.photo == null && reviews.indexOf(r) === i));
      })[0];
      if (!rev) return;
      var html = card(rev, labels, (section.id || 'rev') + '-' + (i + 1));
      if (!html) return;
      box.innerHTML = html;
      box.hidden = false;
    });

    section.addEventListener('click', function (e) {
      var help = e.target.closest('[data-lp-rev-helpful]');
      if (help) {
        var lbl = help.querySelector('[data-lp-rev-helpful-label]');
        if (lbl) lbl.textContent = labels.thanks;
        help.disabled = true;
        try { localStorage.setItem('amb_rev_helpful_' + help.dataset.key, '1'); } catch (err) {}
        return;
      }
      var zoom = e.target.closest('[data-lp-rev-zoom]');
      if (zoom) {
        var img = zoom.querySelector('img');
        var src = zoom.dataset.full || (img && img.currentSrc) || (img && img.src);
        if (!src) return;
        var lb = lightbox(labels);
        var big = lb.querySelector('img');
        big.src = src;
        big.alt = img ? img.alt : '';
        lb.setAttribute('open', '');
        document.documentElement.style.overflow = 'hidden';
      }
    });

    /* Bereits als hilfreich markiert? Dann Button so lassen, wie er war. */
    section.querySelectorAll('[data-lp-rev-helpful]').forEach(function (b) {
      try {
        if (localStorage.getItem('amb_rev_helpful_' + b.dataset.key)) {
          var l = b.querySelector('[data-lp-rev-helpful-label]');
          if (l) l.textContent = labels.thanks;
          b.disabled = true;
        }
      } catch (e) {}
    });
  }

  function boot() { document.querySelectorAll('.lp-rev-sec').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
